import React from "react";
import Metasploit_img from "../../assets/images/cybertools/metasploit-framework-logo.svg.png";
import Burp_Suite_img from "../../assets/images/cybertools/BurpSuite-logo.png";
import Wireshark_img from "../../assets/images/cybertools/Wireshark_Logo.svg.png";
import Nmap_img from "../../assets/images/cybertools/nmap.png";
import Autopsy_img from "../../assets/images/cybertools/Autopsy_Digital_Forensics_Logo.png";
import Ettercap_img from "../../assets/images/cybertools/Ettercap.png";
import sqlmap_img from "../../assets/images/cybertools/Sqlmap.png";
import Acunetix_img from "../../assets/images/cybertools/Acunetix-logo.png";
import Angry_IP_Scanner_img from "../../assets/images/cybertools/Angry_ip_scan_logo.svg.png";
import BeEF_img from "../../assets/images/cybertools/Beef_project_logo.png";
import OWASP_ZAP_img from "../../assets/images/cybertools/Owasp.png";
import Aircrack_ng_img from "../../assets/images/cybertools/Aircrack-ng-new-logo.png";
import John_the_Ripper_img from "../../assets/images/cybertools/John_the_ripper-logo.png";
import Malt_ego_img from "../../assets/images/cybertools/Maltego_logo.png";
import Nikto_img from "../../assets/images/cybertools/Nikto-logo.png";
import Snort_img from "../../assets/images/cybertools/snort-logo.png";
import Hydra_img from "../../assets/images/cybertools/hydra-logo.png";
import w3af_img from "../../assets/images/cybertools/w3af-logo.png";
import netcat_img from "../../assets/images/cybertools/netcat-logo.png";
import OpenVAS_img from "../../assets/images/cybertools/Openvas-logo.png";
import Nessus_img from "../../assets/images/cybertools/Nessus-logo.png";
import Ghidra_img from "../../assets/images/cybertools/Ghidra-logo.png";
import Kismet_img from "../../assets/images/cybertools/Kismet-logo.png";
import Hashcat_img from "../../assets/images/cybertools/Hashcat-logo.png";
import Kali_Linux_img from "../../assets/images/cybertools/Kali-dragon-icon.svg.png";
import Volatility_img from "../../assets/images/cybertools/Volatility-newest-png-crop.png";
import GDB_img from "../../assets/images/cybertools/GDB.png";
import IDA_Pro_img from "../../assets/images/cybertools/IDA-Pro-Computer-License-Linux.png";
import Masscan_img from "../../assets/images/cybertools/Masscan-logo.png";
import Trivy_img from "../../assets/images/cybertools/Trivy-logo.png";
import Shodan_img from "../../assets/images/cybertools/shodan-logo.png";
import Gobuster_img from "../../assets/images/cybertools/Gobuster-logo.png";
import Fiddler_img from "../../assets/images/cybertools/Fiddler-logo.png";

const allTools = [
  // --- Cybersecurity Tools Added Below ---

  // Tools from the image
  {
    name: "Metasploit", 
   icon: Metasploit_img,
    
  },
  {
    name: "Burp Suite",
    icon: Burp_Suite_img,
   
  },
  {
    name: "Wireshark",
    icon: Wireshark_img,
   
  },
  {
    name: "Nmap",
    icon: Nmap_img,
   
  },
  {
    name: "Autopsy",
    icon: Autopsy_img,
   
  },
  {
    name: "Ettercap",
    icon: Ettercap_img,
    
  },
  {
    name: "sqlmap",
    icon: sqlmap_img,
   
  },
  {
    name: "Aircrack-ng",
    icon: Aircrack_ng_img,
  
  },
  {
    name: "Snort",
    icon: Snort_img,
    
  },
  {
    name: "John the Ripper",
    icon: John_the_Ripper_img,
    
  },
  {
    name: "Hydra",
    icon: Hydra_img,
    
  },
  {
    name: "Acunetix",
    icon: Acunetix_img,

  },
  {
    name: "Nikto",
    icon: Nikto_img,
   
  },
  {
    name: "w3af",
    icon: w3af_img,
  
  },
  {
    name: "Netcat",
    icon: netcat_img,
  
  },
  {
    name: "OpenVAS",
    icon: OpenVAS_img,
 
  },
  {
    name: "Nessus",
    icon: Nessus_img,
   
  },
  {
    name: "Angry IP Scanner",
    icon: Angry_IP_Scanner_img,
   
  },
  {
    name: "Ghidra",
    icon: Ghidra_img,
    
  },
  {
    name: "BeEF",
    icon: BeEF_img,

  },
  {
    name: "OWASP ZAP",
    icon: OWASP_ZAP_img,
    
  },
  {
    name: "Maltego",
    icon: Malt_ego_img,

  },
  {
    name: "Kismet",
    icon: Kismet_img,
    
  },

  // Additional cybersecurity tools
  {
    name: "Hashcat",
    icon: Hashcat_img,
 
  },
  {
    name: "Kali Linux",
    icon: Kali_Linux_img,

  },
  {
    name: "Volatility",
    icon: Volatility_img,
 
  },
  {
    name: "GDB",
    icon: GDB_img,
  
  },
  {
    name: "IDA Pro",
    icon: IDA_Pro_img,
   
  },
  {
    name: "Masscan",
    icon: Masscan_img,

  },
  {
    name: "Trivy",
    icon: Trivy_img,
    
  },
  {
    name: "Shodan",
    icon: Shodan_img,

  },
  {
    name: "Gobuster",
    icon: Gobuster_img,

  },
  {
    name: "Fiddler",
    icon: Fiddler_img,

  },
];

// Split the tools into two rows for different scrolling directions
const toolsRow1 = allTools.slice(0, 16); // Adjusted slice for better balance
const toolsRow2 = allTools.slice(16); // Adjusted slice for better balance

// --- Components ---

// Component for a single tool card
const ToolCard = ({ name, iconUrl, color }) => (
  <div
    className="
      d-flex flex-column align-items-start p-2 m-2 
      bg-white shadow-sm rounded-4 
      tool-card-bs flex-shrink-0
    "
    style={{
      transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
      // minWidth: "180px", // Increased min-width for larger icon
      "--bs-card-hover-scale": "1.03",
      "--bs-card-hover-shadow": "0 .5rem 1rem rgba(0,0,0,.15)",
    }}
  >
    {/* Icon/Image Placeholder Area */}
    <div
      className="d-flex justify-content-center align-items-center rounded-3 mb-1 p-1" 
      style={{
        // =========================================================
        //         SIZE INCREASED FROM 3rem to 5rem
        // =========================================================
        width: "5rem", 
        height: "5rem", 
      
      }}
    >
      <img
        src={iconUrl}
        alt={name}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain", // 'contain' ensures the logo fits cleanly inside the box
        }}
      />
    </div>

    {/* Tool Name/Markup Tag */}
    <p
      className="text-dark fw-semibold mb-0 tool-card-text"
      style={{ fontSize: "0.9rem", lineHeight: "1.2", alignSelf: "center" }}
    >
      {name}
    </p>
  </div>
);

// Component that creates the infinite scroll effect
const Marquee = ({ children, direction = "left" }) => {
  // Duplicates content so it looks seamless when scrolling
  const content = (
    <>
      {children}
      {children}
    </>
  );

  return (
    <div
      className="marquee-wrapper overflow-hidden"
      style={{ margin: "1rem 0" }}
    >
      <div
        className={`d-flex flex-nowrap align-items-center ${
          direction === "left" ? "scroll-left" : "scroll-right"
        }`}
      >
        {content}
      </div>
    </div>
  );
};

// Main Application Component
const HackingTools = () => {
  return (
    <div className="bg-light">
      <div className="">
        {/* Header Section */}
        <header className="text-center mb-5">
          {/* Small, orange/yellow header text */}
          <h3
            className="
            small fw-semibold text-uppercase 
            text-warning mb-2 pt-5
            "
            style={{ letterSpacing: "0.15em" }}
          >
            CYBERSECURITY TOOLS
          </h3>

          {/* Main title */}
          <h1
            className="
            display-5 fw-bolder text-dark 
            mb-4 lh-sm
            "
          >
            A Showcase of Industry-Standard Cybersecurity Tools
          </h1>

          {/* Description Paragraph */}
          <p
            className="
            lead text-muted mx-auto
            "
            style={{ maxWidth: "40rem", fontSize: "1.1rem" }}
          >
            Here's a list of various tools used for penetration testing,
            forensics, network analysis, and vulnerability scanning.
          </p>
        </header>

        {/* Tools Card Section - Automatic Scrolling Rows */}
       <section
  style={{
    backgroundColor: "rgba(229, 229, 229, 0.4)", // translucent background
    backdropFilter: "blur(15px)", // blur intensity
    WebkitBackdropFilter: "blur(12px)", // Safari support
    border: "1px solid rgba(255, 255, 255, 0.2)", // subtle border for glass look
  }}
  className="position-relative py-3"
>
  {/* Row 1: Left-to-Right Scroll */}
  <Marquee
    direction="left"
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
    {toolsRow1.map((tool, index) => (
      <ToolCard
        key={`row1-${index}`}
        name={tool.name}
        iconUrl={tool.icon}
        color={tool.color}
      />
    ))}
  </Marquee>

  {/* Row 2: Right-to-Left Scroll */}
  <Marquee direction="right">
    {toolsRow2.map((tool, index) => (
      <ToolCard
        key={`row2-${index}`}
        name={tool.name}
        iconUrl={tool.icon}
        color={tool.color}
      />
    ))}
  </Marquee>

  {/* Custom Styles for Animation and Card Effects */}
  <style>{`
    /* Animation Keyframes */
    @keyframes scroll-left-to-right {
      from {
        transform: translateX(-50%);
      }
      to {
        transform: translateX(0%);
      }
    }

    @keyframes scroll-right-to-left {
      from {
        transform: translateX(0%);
      }
      to {
        transform: translateX(-50%);
      }
    }

    .scroll-left {
      animation: scroll-left-to-right 20s linear infinite;
    }

    .scroll-right {
      animation: scroll-right-to-left 20s linear infinite;
    }

    .tool-card-bs:hover {
      transform: scale(var(--bs-card-hover-scale, 1.03));
      box-shadow: var(
        --bs-card-hover-shadow,
        0 0.5rem 1rem rgba(0, 0, 0, 0.15)
      ) !important;
      animation-play-state: paused;
    }

    
  /* ✅ Always Truncate (All Devices) */
  .tool-card-text {
    width: 80px;           /* Fixed width for all devices */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    margin: 0 auto;
    text-align: center;
    font-weight: 500;
  }

    /* Pause animation on hover */
    .marquee-wrapper:hover .scroll-left,
    .marquee-wrapper:hover .scroll-right {
      animation-play-state: paused;
    }

    @media (max-width: 768px) {
      .tool-card-text {
        max-width: 100px;
      }
    }
  `}</style>
</section>

      </div>
    </div>
  );
};

export default HackingTools;